import { render } from "./Team_partner_en.vue?vue&type=template&id=6a0b33ba&scoped=true"
import script from "./Team_partner_en.vue?vue&type=script&lang=js"
export * from "./Team_partner_en.vue?vue&type=script&lang=js"

import "./Team_partner_en.vue?vue&type=style&index=0&id=6a0b33ba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a0b33ba"

export default script